import { EQ_OBTENER_START } from "../../const/actionTypes";

export const GetEquipos = (payload) => ({
  type: EQ_OBTENER_START,
  payload,
});
